var _circle, _path, _circle2, _path2, _path3, _path4, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ff475a",
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-6.28-.237-12.504-.681-18.671l-118.871-118.871-267.193 280.525 113.111 112.401c5.828.397 11.705.616 17.634.616 141.385 0 256-114.615 256-256z",
    fill: "#d1093a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ffe000",
    r: 193.748
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m449.748 256c0-107.004-86.744-193.748-193.748-193.748v387.496c107.004 0 193.748-86.744 193.748-193.748z",
    fill: "#ffc200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m322.641 372.443c-13.038-24.895-38.573-40.36-66.641-40.36s-53.603 15.465-66.641 40.36l-26.576-13.918c18.233-34.814 53.951-56.441 93.217-56.441s74.983 21.627 93.217 56.441z",
    fill: "#555a66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m256 302.083v30c28.067 0 53.603 15.465 66.641 40.36l26.576-13.918c-18.234-34.815-53.951-56.442-93.217-56.442z",
    fill: "#333940"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 243,
    fill: "#555a66",
    r: 27
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 359,
    cy: 243,
    fill: "#333940",
    r: 27
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadIcon);
export default __webpack_public_path__ + "static/media/sad-icon.41dfd786980e15618daa288128c3575e.svg";
export { ForwardRef as ReactComponent };